module.exports = __webpack_public_path__ + "static/media/20140518_022311.13c97ebe.jpg";